import BaseBarStack from "./private/BaseBarStack.js";
import Bars from "./private/Bars.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function BarStack(props) {
  return /*#__PURE__*/_jsx(BaseBarStack, {
    ...props,
    BarsComponent: Bars
  });
}